<template>
	<router-view />
</template>

<script>
export default {
	name: "ConsoleHome",
};
</script>
